import { Dispatch, useCallback } from 'react';
import {
  cancelConnectionRequest,
  connectPeer,
} from '../service/ConnectionService';
import { CommunityDiscoverAction } from './useCommunityDiscover';

export const useQuickConnectPeerProfile = (
  discoverDispatch: Dispatch<CommunityDiscoverAction>,
) => {
  return useCallback(
    async (peerGuid: string) => {
      console.debug(`Connecting peer ${peerGuid}`);
      await connectPeer(peerGuid);
      discoverDispatch({
        type: 'QUICK_CONNECT_PEER_PROFILE',
        payload: peerGuid,
      });
    },
    [discoverDispatch],
  );
};

export const useCancelPeerProfile = (
  discoverDispatch: Dispatch<CommunityDiscoverAction>,
) => {
  return useCallback(
    async (peerGuid: string) => {
      console.debug(`Cancel connection peer ${peerGuid}`);
      await cancelConnectionRequest(peerGuid);
      discoverDispatch({
        type: 'CANCEL_CONNECT_PEER_PROFILE',
        payload: peerGuid,
      });
    },
    [discoverDispatch],
  );
};
